import { render, staticRenderFns } from "./section-card.vue?vue&type=template&id=562a5012&scoped=true&"
import script from "./section-card.vue?vue&type=script&lang=js&"
export * from "./section-card.vue?vue&type=script&lang=js&"
import style0 from "./section-card.vue?vue&type=style&index=0&id=562a5012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a5012",
  null
  
)

export default component.exports